import { GetStaticPaths, GetStaticProps } from "next";
import { FunctionComponent } from "react";
import { CanonicalHead } from "../../../components/CanonicalHead";
import { BaseProps } from "../../../lib/sanity/shared";
import {
  getDefaultStaticPaths,
  getDefaultStaticProps,
} from "../../../lib/utils";
import { LayoutWrapper } from "../../../components/LayoutWrapper";

export const getStaticProps: GetStaticProps<BaseProps> = getDefaultStaticProps;

export const getStaticPaths: GetStaticPaths = getDefaultStaticPaths;

const Page: FunctionComponent<BaseProps> = ({ region, lang, ...rest }) => (
  <>
    <CanonicalHead region={region} lang={lang} slug="search" />
    <LayoutWrapper region={region} lang={lang} {...rest} />
  </>
);

export default Page;
